export default "__VITE_ASSET__DtUNSyM1__"